/**
 * How long a sign-in request may hang before the visitor is told something.
 *
 * MEASURED DEFECT (web-stg, bundle main.4a698d99.js, 2026-07-31 — evidence
 * `.mgmt-e2e-verify/login-assert/canon-login.json`, cell
 * `E5-async-hung-request-45s`): with the login request held open and never
 * answered, the Log In button sat disabled showing its spinner for the full
 * 45-second observation window with ZERO toasts, ZERO dialogs and ZERO inline
 * messages. `saidSomething: false`.
 *
 * The probe is not the problem: the SAME probe, on the SAME page, reported the
 * message correctly for a forced network abort (cell `E4-async-error-forced`)
 * and for a forced 500 (cell `B7-500-server-error`). A hang is simply a shape
 * PR #2484 never covered — it fixed the cases where axios REJECTS, and a hang
 * is the case where axios never settles at all.
 *
 * A request that never settles is the worst version of the silent-failure bug
 * the login page has been fighting: the visitor cannot even retry, because the
 * button stays disabled behind the in-flight guard.
 *
 * The fix is a bounded wait. axios turns an exceeded `timeout` into a rejection
 * with NO `response` property, which `isNetworkFailure` already recognises, so
 * the existing "we couldn't reach iYuga" path takes over and the submit guard's
 * release runs — no new error-handling branch, no new copy to translate.
 *
 * 20s is deliberately generous: staging p99 for this endpoint is well under 2s,
 * so this only ever fires on a genuine hang, never on a slow-but-alive request.
 */
export const LOGIN_TIMEOUT_MS = 20000;
